import React, {useEffect} from "react";
import {TorresstreamApi} from "../../../../apis/torrestream-api/torresstream-api";

const Player4uPlayer = ({item, searchKey, imagePath}) => {

    const [videoUrl, setVideoUrl] = React.useState(null);
    const [links, setLinks] = React.useState([]);
    const [search, setSearch] = React.useState(null);
    const [linksLoading, setLinksLoading] = React.useState(false);

    useEffect(() => {
        if (search) {
            return;
        }

        setSearch(item.nameEN ?? item.original_title ?? item.original_name);
    }, [item]);

    useEffect(() => {
        if (!search) {
            return;
        }

        setLinksLoading(true);

        TorresstreamApi.get('generalPlayerSearch').call({key: search}).then(res => {
            setLinks(res);
            if (res.length === 1) {
                setVideoUrl(res[0].url);
            }
            setLinksLoading(false);
        }).catch(() => {
            setLinks([]);
        });
    }, [search]);


    const handleSelectLink = (link) => {
        setVideoUrl(link);
    }

    if (!videoUrl) {
        return (
            <div className="towersStreamViewer__torrents">
                <div className="towersStreamViewer__torrents__background">
                    {linksLoading &&
                        <div
                            className="d-flex flex-column justify-content-center align-items-center ps-4 pe-4 text-center text-light">
                            <div className="spinner-border text-light" role="status">
                            </div>
                            <div>
                                Estamos robando los links de los streams para este episodio
                            </div>
                            <div style={{
                                color: "rgba(255,255,255,0.7)",
                            }}>
                                Esto puede tardar unos segundos
                            </div>
                        </div>}

                    {!linksLoading &&
                        <div className="towersStreamViewer__torrents__content">
                            <div className="towersStreamViewer__torrents__list">
                                <div style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}>
                                    <div className="input-group mb-3">
                                        <input type="text" className="form-control" placeholder="Buscar en Player4u"
                                               id="player4u_searcher" defaultValue={search}
                                               onKeyDown={e => {
                                                   if (e.key === "Enter") {
                                                       setSearch(e.target.value);
                                                   }
                                               }}/>
                                        <button className="btn btn-outline-secondary" type="button"
                                                onClick={() => {
                                                    setSearch(document.getElementById("player4u_searcher").value);
                                                }}>
                                            <i className="fa-solid fa-magnifying-glass"></i>
                                        </button>
                                    </div>
                                </div>
                                <div className="towersStreamViewer__torrents__list__buttons">
                                    {links.map(link => {
                                        return (
                                            <button
                                                className="btn btn-outline-light d-flex flex-row justify-content-center align-items-center"
                                                key={link.url}
                                                onClick={() => handleSelectLink(link.url)}>
                                                {link.title.split("|")?.[2] ?? link.title}
                                            </button>)
                                    })}
                                    {!linksLoading && !links.length &&
                                        <div className="text-center">
                                            <div className="text-light" style={{fontSize: "1.3rem"}}>
                                                No se encontraron streams para este contenido
                                            </div>
                                            <div style={{
                                                color: "rgb(255,255,255, 0.7)",
                                                fontSize: "0.8rem",
                                            }}>
                                                Quizás el contenido no está disponible en este momento
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        )
    }

    return (
        <iframe style={{width: "100%", aspectRatio: "16/9"}}
                allowFullScreen
                src={videoUrl}></iframe>
    );

}

export default Player4uPlayer;
